import { getGemTypeIcon } from "./gemTypeIcons";

// Shape+gem-type combo set (bug #1808 follow-up): filenames are
// "{shape}_{gemtype}.jpg" (all lowercase), one per non-cushion shape x
// gem-type pair — Round, Radiant, Princess, Pear, Oval, Marquise, Heart,
// Emerald, Asscher. Cushion has no file here: the original per-gem-type
// set in gemTypeIcons.js already IS the cushion cut, so it doubles as the
// cushion entry and the default when no shape is known.
const context = require.context(
  "../assets/images/gemtype-shape-photos",
  false,
  /\.jpg$/
);

const GEM_TYPE_SHAPE_ICONS = {};
context.keys().forEach((key) => {
  const filename = key.replace("./", "").replace(".jpg", "");
  const separatorIndex = filename.indexOf("_");
  if (separatorIndex === -1) return;
  const shape = filename.slice(0, separatorIndex).toUpperCase();
  const gemType = filename.slice(separatorIndex + 1).toUpperCase();
  if (!GEM_TYPE_SHAPE_ICONS[gemType]) GEM_TYPE_SHAPE_ICONS[gemType] = {};
  GEM_TYPE_SHAPE_ICONS[gemType][shape] = context(key);
});

export const getGemTypeShapeIcon = (gemTypeName, shapeName) => {
  if (!gemTypeName) return null;
  const gemType = String(gemTypeName).trim().toUpperCase();
  const shape = shapeName ? String(shapeName).trim().toUpperCase() : "";
  if (shape && shape !== "CUSHION") {
    const combo = GEM_TYPE_SHAPE_ICONS[gemType]?.[shape];
    if (combo) return combo;
  }
  return getGemTypeIcon(gemType);
};

export default GEM_TYPE_SHAPE_ICONS;
